import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { validateUuid } from '@/utils/validate-uuid';
import { Resolution886ReportService } from '@/infra/services/resolution-886-report';

export interface GetResolution886CategoryQuestionParams {
	organization_id: string;
	company_id: string;
	review_id: string;
	report_id: string;
	category_key?: string;
	assessment_id?: string;
	activity_id?: string;
}

const Service = Resolution886ReportService.getInstance();

export const useGetResolution886CategoryQuestion = (params: GetResolution886CategoryQuestionParams) => {
	const isEnabled = validateUuid([params.organization_id, params.company_id, params.review_id, params.report_id]);

	return useQuery({
		queryKey: [QUERY_KEYS.GET_RESOLUTION_886_CATEGORY_QUESTION, params],
		queryFn: async () =>
			Service.getCategoryQuestion({
				...params,
				category_key: params.category_key || undefined,
				assessment_id: params.assessment_id || undefined,
				activity_id: params.activity_id || undefined
			}),
		enabled: isEnabled
	});
};
